'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _immutable = require('redux-form/immutable');

var _RenderField = require('shared/components/RenderField');

var _RenderField2 = _interopRequireDefault(_RenderField);

var _styled = require('../styled');

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ContactUsForm = function ContactUsForm(_ref) {
  var formRef = _ref.formRef,
      handleSubmit = _ref.handleSubmit,
      initialValues = _ref.initialValues;
  return _react2.default.createElement(_antd.Form, {
    onSubmit: handleSubmit,
    ref: formRef
  }, _react2.default.createElement(_immutable.Field, {
    component: _RenderField2.default,
    label: _react2.default.createElement('span', null, 'Name ', _react2.default.createElement(_styled2.default.MandatorySign, null, '*')),
    name: 'name',
    placeholder: 'Enter name',
    type: 'text',
    disabled: initialValues && initialValues.name
  }), _react2.default.createElement(_immutable.Field, {
    component: _RenderField2.default,
    label: _react2.default.createElement('span', null, 'Email ', _react2.default.createElement(_styled2.default.MandatorySign, null, '*')),
    name: 'email',
    disabled: initialValues && initialValues.email,
    placeholder: 'Enter email',
    type: 'text'
  }), _react2.default.createElement(_immutable.Field, {
    component: _RenderField2.default,
    label: _react2.default.createElement('span', null, 'Telephone'),
    name: 'phone',
    allowClear: true,
    placeholder: 'Enter telephone',
    type: 'phone-number'
  }), _react2.default.createElement(_immutable.Field, {
    component: _RenderField2.default,
    label: _react2.default.createElement('span', null, 'Message ', _react2.default.createElement(_styled2.default.MandatorySign, null, '*')),
    name: 'message',
    placeholder: 'Enter message',
    type: 'textarea'
  }));
};

exports.default = ContactUsForm;